type NonEmptyArray<T> = [T, ...T[]];

function assertNonEmpty<T>(array: Array<T>): NonEmptyArray<T> {
    if (array.length === 0) {
        throw new Error("Array should not be empty");
    }
    return array as NonEmptyArray<T>;
}

function nonEmptyOrUndefined<T>(array: Array<T>): NonEmptyArray<T> | undefined {
    if (array.length === 0) {
        return undefined;
    }
    return array as NonEmptyArray<T>;
}

export { assertNonEmpty, nonEmptyOrUndefined, type NonEmptyArray };
